module.exports = __webpack_public_path__ + "img/icehockey.91151037.svg";